module.exports = __webpack_public_path__ + "static/media/bg_symbol_3.cea4aba4.svg";